module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-7-5872afd5252dde7ff9fce170b488497b.jpg";